const locale = require('./newTaskAttachmentModal.i18n.json');

/*@ngInject*/
const NewTaskAttachmentModalController = function ($rootScope, $scope, $timeout, options,
                                                   coreConstant, preferenceModel, attachmentUtil, isUnderwriterUser) {

    $scope.i18n = locale;

    $scope.viewModel = {
        attachment: {},
        typeDataItems: null,
        uploadedFile: null,
        isUnderwriterUser: isUnderwriterUser
    };

    $scope.onConfirm = function () {
        $scope.$close({attachment: $scope.viewModel.attachment, file: $scope.viewModel.uploadedFile});
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.storeUploadedFile = function (uploadedFile) {
        if (uploadedFile && attachmentUtil.validateAttachment(uploadedFile, _.get($scope.i18n, 'unacceptableTypeAndSize'))) {
            $timeout(function () {
                $scope.viewModel.uploadedFile = uploadedFile;
                if (!$scope.viewModel.attachment) {
                    $scope.viewModel.attachment = {};
                }
                $scope.viewModel.attachment.name = uploadedFile.name;
                $scope.viewModel.attachment.size = uploadedFile.size;
                let fileSize = attachmentUtil.convertAttachmentSize(uploadedFile.size)
                $scope.viewModel.attachment.byteCountToDisplaySize = `(${fileSize})`
            }, 0);
        }
    };

    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
        $scope.storeUploadedFile(file);
    });

    $scope.resetTypeDropdown = function () {
        $scope.viewModel.attachment.type = '';
    };

    $scope.setTypeValue = function (value) {
        $scope.viewModel.attachment.type = value;
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.viewModel.attachment.name;
    };

    $scope.getTypePrompt = function () {
        return $scope.viewModel.attachment.type ? $scope.viewModel.attachment.type : $scope.viewModel.pleaseChooseString;
    };

    $scope.fileSelected = function (file) {
        if (file) {
            $scope.storeUploadedFile(file);
        }
    };

    function loadDataSets() {
        attachmentUtil.getAttachmentTypes().then(function (result) {
            $scope.viewModel.typeDataItems = result;
        });
    }

    function init() {
        $scope.viewModel = _.assign($scope.viewModel, {
            title: options.title ? options.title : $scope.i18n.title,
            cancelButton: options.cancelButtton ? options.cancelButton : $scope.i18n.cancelButton,
            uploadButton: options.uploadButton ? options.uploadButton : $scope.i18n.uploadFile,
            chooseFileString: options.chooseFileString ? options.chooseFileString : $scope.i18n.chooseFile,
            pleaseChooseString: options.pleaseChooseString ? options.pleaseChooseString : $scope.i18n.type,
            fileDescPlaceholder: options.fileDescPlaceholder ? options.fileDescPlaceholder : $scope.i18n.fileDescription
        });

        loadDataSets();
    }

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

    init();
};

angular.module('gw-um-submission')
    .controller('newTaskAttachmentModalController', NewTaskAttachmentModalController);
